import { render, staticRenderFns } from "./certificates-table-index.vue?vue&type=template&id=67cf74e1&scoped=true"
import script from "./certificates-table-index.vue?vue&type=script&lang=js"
export * from "./certificates-table-index.vue?vue&type=script&lang=js"
import style0 from "./certificates-table-index.vue?vue&type=style&index=0&id=67cf74e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cf74e1",
  null
  
)

export default component.exports